import 'whatwg-fetch'; // For IE11
import 'core-js/modules/es.array.iterator'; // Make Gmaps Loader work on IE11
import { Loader } from '@googlemaps/js-api-loader/dist/index.umd';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import defineInfoWindow from '../map/InfoWindow';
import getIcon from '../map/icon';
import ContextualDisplayer from '../front/cookies/ContextualDisplayer';

/* global google, GMAP_API_KEY, REST_CREDENTIALS */

document.addEventListener('DOMContentLoaded', () => {
  const $locator = document.querySelector('.js-locator');
  const gmapLoader = new Loader({
    apiKey: GMAP_API_KEY,
    version: 'weekly',
  });

  let iw;

  function handleLoadError() {
    $locator.style.display = 'none';
  }

  function openMarker(marker) {
    iw.marker = marker;

    const content = marker.iwContent;

    marker.setIcon(getIcon('primary'));
    iw.update(marker.position || marker.center, content);
    iw.show();
  }

  function closeMarker(marker) {
    marker.setIcon(getIcon('light'));
    iw.hide();
    iw.marker = null;
  }

  function toggleMarker(marker) {
    if (iw.marker && iw.marker === marker) {
      closeMarker(marker);
    } else {
      openMarker(marker);
    }
  }

  function initLocator(places) {
    const $map = $locator.querySelector('.js-locator-map');

    const map = new google.maps.Map($map, {
      center: { lat: 46.227636, lng: 2.213749 },
      zoom: 2,
      maxZoom: 17,
      disableDefaultUI: true,
      zoomControl: true,
      clickableIcons: false,
    });

    const InfoWindow = defineInfoWindow();
    iw = new InfoWindow(map);

    const markers = [];

    // Save places data and create markers
    places
      .filter(place => place.acf.location?.lat && place.acf.location?.lng)
      .forEach(place => {
        const iwContent = document.createElement('div');
        iwContent.classList.add('c-map__iw-content');
        iwContent.innerHTML = `
        <p>
          <strong>${place.title.rendered || place.acf.h1_title}</strong><br>
          ${place.acf.location.name}, <br>${place.acf.location.post_code} ${place.acf.location.city}
        </p>
        <a href="${place.link}">Voir cette agence</a>
      `;

        // Create marker
        const marker = new google.maps.Marker({
          position: {
            lat: place.acf.location.lat,
            lng: place.acf.location.lng,
          },
          map,
          icon: getIcon(),

          // Custom props
          iwContent,
        });

        marker.addListener('click', function () {
          toggleMarker(this);
        });

        markers.push(marker);
      });

    const cluster = new MarkerClusterer(map, markers, {
      ignoreHidden: true,
      gridSize: 70,
      styles: [
        {
          width: 55,
          height: 55,
          className: 'c-map__cluster',
        },
      ],
    });

    // Close infoWindow when clicking outside of a marker
    google.maps.event.addListener(map, 'click', () => {
      if (iw.marker) {
        closeMarker(iw.marker);
      }
    });
    // Prevent InfoWindow to capture map's click, see : https://github.com/googlemaps/js-samples/issues/4
    google.maps.OverlayView.preventMapHitsFrom(iw.iw);

    cluster.fitMapToMarkers();
  }

  function loadLocator() {
    // Fetch data
    console.log('loadLocator');
    window
      .fetch($locator.getAttribute('data-fetch-url'), {
        method: 'GET',
      })
      .then(response => {
        const contentType = response.headers.get('content-type');

        // Return JSON data
        if (contentType && contentType.indexOf('application/json') !== -1) {
          return response.json();
        }

        // Else throw an error
        throw new Error('Impossible de récupérer la source.');
      })
      .then(json => {
        // Load Maps API
        gmapLoader
          .load()
          .then(() => {
            initLocator(json);
          })
          .catch(handleLoadError);
      })
      .catch(handleLoadError);
  }

  if ($locator) {
    new Loader({
      apiKey: GMAP_API_KEY || '',
      version: 'weekly',
    })
      .load()
      .then(loadLocator)
      .catch(() => {});
  }

  if ($locator) {
    (window._axcb = window._axcb || []).push(sdk => {
      sdk.on('cookies:complete', choices => {
        const event = new CustomEvent('cookies:updateChoice', {
          detail: choices,
        });
        document.dispatchEvent(event);
        if (event.detail.gmaps && !window?.google?.maps) {
          new Loader({
            apiKey: GMAP_API_KEY || '',
            version: 'weekly',
          })
            .load()
            .then(loadLocator)
            .catch(() => {});
        }
      });
    });

    const locatorPlaceholder = document.querySelector('.js-locator-placeholder');
    const map = document.querySelector('.js-locator-map');
    new ContextualDisplayer(locatorPlaceholder, 'gmaps', consent => {
      if (consent) {
        locatorPlaceholder.setAttribute('hidden', '');
        map.removeAttribute('hidden');
      } else {
        locatorPlaceholder.removeAttribute('hidden');
        map.setAttribute('hidden', '');
      }
    });
  }
});
